import { render, staticRenderFns } from "./botTable.vue?vue&type=template&id=8f256b14&scoped=true"
import script from "./botTable.vue?vue&type=script&lang=js"
export * from "./botTable.vue?vue&type=script&lang=js"
import style0 from "./botTable.vue?vue&type=style&index=0&id=8f256b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f256b14",
  null
  
)

export default component.exports